// extracted by mini-css-extract-plugin
export default {"textDisable":"AssociatedWirelessList_textDisable__pbO1r","table":"AssociatedWirelessList_table__AgguL"};